module.exports = __webpack_public_path__ + "img/manage-category.9cf15614.svg";